import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { createMuiTheme } from '@material-ui/core/styles';
import { BrowserRouter } from 'react-router-dom';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import DateFnsUtils from '@date-io/date-fns';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';

//Mobx stores
import userStore from './mobx-stores/userStore';
import commonStore from './mobx-stores/commonStore';
import documentStore from './mobx-stores/documentStore';
import adminStore from './mobx-stores/adminStore';
import imageStore from './mobx-stores/imageStore';
import dashboardStore from './mobx-stores/dashboardStore';
import statisticsStore from './mobx-stores/statisticsStore';
import templateStore from './mobx-stores/templateStore'
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0F7FD3'
    },
    dark: '#121828',
    cloudyBlue: '#bfc5d2',
    silver: '#c2c6cd',
    paleGray: '#f9f9fd',
    paleGray2: '#f8f8fd',
    red: '#e92944',
    white: '#ffffff',
    coolGray: '#89969f',
    coolGray2: '#9097a2',
    black: '#000000',
    steelGray: '#747f87',
    charcoalGray: '#3e464e',
    slateGray: '#585c65',
    blue: '#1077ff',
    lightGray: '#95a8d2',
    darkBlue: '#141c31',
    brownishGray: '#202430',
    steelGray2: '#868a8e',
    battleShipGray: '#7a7c80',
    lightBlueGray:'#bdc9e3',
    darkBlueGray: '#17213d',
    turquoise: '#04bfa8',
    fieldGray: '#484b51',
    dullGray: '#505c79',
    newGray: '#2a303f',
    tempBlue: '#2a3759',
    lightBlue: '#9ea7b9',
    dullRed: '#ff6868'

    
  },
  typography: {
    button: {
      textTransform: 'none'
    },
    useNextVariants: true,
    fontFamily: 'Roboto',
  },
  overrides: {
    MuiInputLabel: { // Name of the component ⚛️ / style sheet
      root: { // Name of the rule
        color: "#868a8e",
        "&$focused": { // increase the specificity for the pseudo class
          color: "#868a8e"
        }
      }
    },
    MuiFilledInput: {
      root: {
          color: 'white',
          borderRadius: '4px',
          backgroundColor: '#202430',
          paddingRight: '0px',
          paddingTop: '0px'
      }

  },

  }
});

const stores = {
  userStore,
  commonStore,
  documentStore,
  adminStore,
  imageStore,
  dashboardStore,
  statisticsStore,
  templateStore
};

configure({ enforceActions: 'observed' })

ReactDOM.render((
  <MuiPickersUtilsProvider utils={DateFnsUtils} style={{background: 'white'}}>
  <MuiThemeProvider theme={theme}>
    <Provider {...stores}>
        <BrowserRouter>
              <App  />
        </BrowserRouter>
    </Provider>
  </MuiThemeProvider>
  </MuiPickersUtilsProvider>
), document.getElementById('root'));

serviceWorker.unregister();
